
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 8a8 8 0 1116 0A8 8 0 010 8zm12.06-2.118v-.345a2.266 2.266 0 01-2.256-2.056v-.208h-1.63v6.463a1.369 1.369 0 11-.953-1.309V6.773a2.992 2.992 0 102.582 2.963V6.434a3.869 3.869 0 002.257.721V5.882z","fill":"currentColor"}})])
          )
        }
      }
    